export const PATHNAMES = {
  ROOT: "/",
  WILDCARD: "*",

  VEHICLEHISTORY_HOME: "/vehiclehistory/",
  VEHICLEHISTORY_TRUECAR: "/vehiclehistory/truecar",
  VEHICLEHISTORY_TRUECAR_8900: "/vehiclehistory/truecar8900",
  VEHICLEHISTORY_LOGIN: "/vehiclehistory/login",
  VEHICLEHISTORY_SUBSCRIPTION_BENEFITS: "/vehiclehistory/subscription-benefits",
  VEHICLEHISTORY_SEARCH_BY_LICENSE_PLATE:
    "/vehiclehistory/search-by-license-plate",
  VEHICLEHISTORY_TERMS_OF_USE: "/vehiclehistory/terms-of-use",
  VEHICLEHISTORY_REPORTS: "/vehiclehistory/vehicle-history-reports",
  VEHICLEHISTORY_SAMPLE_REPORT: "/vehiclehistory/sample-vehicle-history-report",
  VEHICLEHISTORY_AUTOSHOPPERS_GUIDE: "/vehiclehistory/autoshoppers-guide",
  VEHICLEHISTORY_VIN_BASICS: "/vehiclehistory/vin-basics",
  VEHICLEHISTORY_VIN_BASICS_DECODE: "/vehiclehistory/vin-basics#decode",
  VEHICLEHISTORY_VIN_BASICS_FINDVIN: "/vehiclehistory/vin-basics#findvin",
  VEHICLEHISTORY_WHY_BUY_VHR: "/vehiclehistory/why-buy-vhr",
  VEHICLEHISTORY_ODOMETER_FRAUD: "/vehiclehistory/odometer-fraud",
  VEHICLEHISTORY_CALL_FOR_ACTION: "/vehiclehistory/call-for-action",
  VEHICLEHISTORY_TITLE_BRANDS: "/vehiclehistory/title-brands",
  VEHICLEHISTORY_FAQ: "/vehiclehistory/faq",
  VEHICLEHISTORY_BUYBACK_TERMS: "/vehiclehistory/buyback-terms",
  VEHICLEHISTORY_CONTACT: "/vehiclehistory/contact",
  VEHICLEHISTORY_DISPUTE: "/vehiclehistory/dispute",
  VEHICLEHISTORY_FREE_ONLINE_DELIVERY: "/vehiclehistory/free-online-delivery",
  VEHICLEHISTORY_SECURE_SHOPPING: "/vehiclehistory/secure-shopping",
  VEHICLEHISTORY_GLOSSARY: "/vehiclehistory/glossary",
  VEHICLEHISTORY_AUTOCHECK_SCORE: "/vehiclehistory/autocheck-score",
  VEHICLEHISTORY_PATENT_NOTICE: "/vehiclehistory/patent-notice",
  VEHICLEHISTORY_BUYBACK_PROTECTION:
    "/vehiclehistory/vehicle-buyback-protection",
  VEHICLEHISTORY_CAR_GURUS: "/vehiclehistory/car-gurus",
  VEHICLEHISTORY_FREE_SCORE: "/vehiclehistory/free-score",
  VEHICLEHISTORY_MY_VEHICLE_OFFERS: "/vehiclehistory/my-vehicle-offers",
  VEHICLEHISTORY_PREFERENCES_UPDATED: "/vehiclehistory/preferences-updated",
  VEHICLEHISTORY_RECALL_CHECK: "/vehiclehistory/recall-check",
  VEHICLEHISTORY_CAR_ADVISE: "/vehiclehistory/car-advise",
  VEHICLEHISTORY_CARSCOM: "/vehiclehistory/carscom",
  VEHICLEHISTORY_BACKED_BY_EXPERIAN: "/vehiclehistory/backed-by-experian",
  VEHICLEHISTORY_AUTOCHECK_VS_CARFAX: "/vehiclehistory/autocheck-vs-carfax",
  VEHICLEHISTORY_AUTOCHECK_VS_BARGAIN: "/vehiclehistory/autocheck-vs-bargain",
  VEHICLEHISTORY_FLOOD_RISK_CHECK: "/vehiclehistory/flood-risk-check",
  VEHICLEHISTORY_AFFILIATE_PROGRAM: "/vehiclehistory/affiliate-program",
  VEHICLEHISTORY_PAYMENT_GATEWAY: "/vehiclehistory/payment-gateway",
  VEHICLEHISTORY_CHECKOUT: "/vehiclehistory/checkout",
  VEHICLEHISTORY_CHECKOUT_ORDER_CONFIRMATION:
    "/vehiclehistory/checkout/order-confirmation",
  VEHICLEHISTORY_DASHBOARD: "/vehiclehistory/dashboard",
  VEHICLEHISTORY_DASHBOARD_PROFILE: "/vehiclehistory/dashboard/my-profile-tab",
  VEHICLEHISTORY_DASHBOARD_REPORT: "/vehiclehistory/dashboard/my-report-tab",
  VEHICLEHISTORY_UPDATE_PASSWORD: "/vehiclehistory/update-password",
  VEHICLEHISTORY_DASHBOARD_REGISTER_BUYBACK:
    "/vehiclehistory/dashboard/register-for-buyback-protection-tab",
  VEHICLEHISTORY_YOUR_AD_CHOICES: "/vehiclehistory/your-ad-choices",

  FULL_VEHICLE_REPORT_PREFIX: "/vehiclehistory/full-vehicle-report/",
  FULL_VEHICLE_REPORT_WITH_OWNER:
    "vehiclehistory/full-vehicle-report/:vin/:isOwner",
  FULL_VEHICLE_REPORT_WITHOUT_OWNER: "vehiclehistory/full-vehicle-report/:vin",
  VEHICLEHISTORY_FAQ_ANCHOR_ACESS: "/vehiclehistory/faq#acess",
  VEHICLEHISTORY_FAQ_ANCHOR_BUYBACK: "/vehiclehistory/faq#buyback",
  VEHICLEHISTORY_FAQ_ANCHOR_FORGOT: "/vehiclehistory/faq#forgot",
  VEHICLEHISTORY_FAQ_ANCHOR_SAMPLE: "/vehiclehistory/faq#sample",
  VEHICLEHISTORY_FAQ_ANCHOR_SCORE: "/vehiclehistory/faq#score",
  VEHICLEHISTORY_RECALL_RESULTS: "/vehiclehistory/recall-results",
  VEHICLEHISTORY_BUYBACK_PROTECTION_ANCHOR_CLAIM: "/vehiclehistory/vehicle-buyback-protection#claim",
  VEHICLEHISTORY_BUYBACK_PROTECTION_ANCHOR_COVERED: "/vehiclehistory/vehicle-buyback-protection#covered",
  VEHICLEHISTORY_BUYBACK_PROTECTION_ANCHOR_HOW: "/vehiclehistory/vehicle-buyback-protection#how",
  VEHICLEHISTORY_BUYBACK_PROTECTION_ANCHOR_PROTECTION: "/vehiclehistory/vehicle-buyback-protection#protection",
  VEHICLEHISTORY_BUYBACK_PROTECTION_ANCHOR_REGISTER: "/vehiclehistory/vehicle-buyback-protection#register",
  VEHICLEHISTORY_BUYBACK_PROTECTION_ANCHOR_EMPTY: "/vehiclehistory/vehicle-buyback-protection#",
};